// extracted by mini-css-extract-plugin
export default {"container":"DrekKF","content":"D2YKil"};